const debugMode = false;

const debug = (...msg) => {
    if (debugMode) {
        console.warn(msg);
    }
}

export default debug;